import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";
const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = args.listeners["selection-change"] || function () { };
  const changePort = listeners["change-port"] || function () { };
  const handleShare = listeners["handleShare"] || function () { };
  const deptLevelCode = args.props.deptLevelCode;
  function handleDelete({ row }) {
    Bus.$emit("deleteArticle", row);
  }
  function handleUpdate({ row }) {
    router.push({
      path: "/periodicalArticle/add",
      query: {
        uuid: row.uuid,
      },
    });
  }
  function upLine({ row }) {
    Bus.$emit("upLine", row);
  }
  function downLine({ row }) {
    Bus.$emit("downLine", row);
  }
  const Deal = ({ props: { vo } }) => {
    let isMyCollege = vo.row.originDeptLevelCode == deptLevelCode;
    let canShare = vo.row.canShare;
    let canUpdate = vo.row.canUpdate;
    const dealConf = [
      // ["icon-edit", "编辑", () => handleUpdate(vo), "periodicalArticle:update"],
      // [
      //   "icon-delete",
      //   "删除",
      //   () => handleDelete(vo),
      //   "periodicalArticle:delete",
      // ],
    ];
    if (canUpdate) {
      // 版权方为本学院 && 下线状态
      dealConf.push(["icon-edit", "编辑", () => handleUpdate(vo), "periodicalArticle:update"]);
    } else {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "periodicalArticle:update"]);
    }
    dealConf.push(["icon-delete", "删除", () => handleDelete(vo), "periodicalArticle:delete"]);

    if (vo.row.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => downLine(vo),
        "periodicalArticle:online",
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => upLine(vo),
        "periodicalArticle:online",
      ]);
    }

    dealConf.push([
      vo.row.onlineStatus == 1
        ? "iconfont icxiugaizhanshizhongduan iconfont-adapt-disabled"
        : "iconfont icxiugaizhanshizhongduan iconfont-adapt",
      "修改展示终端",
      vo.row.onlineStatus == 1 ? () => { } : () => changePort(vo.row),
      "periodicalArticle:updateDisplay",
    ]);
    if (canShare){
      dealConf.push(["icon-share", "共享管理", () => handleShare(vo.row), "periodicalArticle:share"]);
    } else {
      dealConf.push(["icon-share-none", "共享管理", () => {}, "periodicalArticle:share"]);
    }

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const NewsSource = ({ props: { vo } }) => {
    return <span>{vo.row.newsSource || "--"}</span>;
  };
  const ArticleAuthor = ({ props: { vo } }) => {
    return <span>{vo.row.articleAuthor || "--"}</span>;
  };
  const ArticleTitle = ({ props: { vo } }) => {
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          router.push({
            path: "/periodicalArticle/detail",
            query: {
              uuid: vo.row.uuid
            }
          })
        }}
      >
        {vo.row.articleTitle}
      </div>
    );
  };
  
  // function selectable(row, index) {
  //   return row.canShare == 1;
  // }

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      // selectable: selectable
    },
    {
      label: "文章标题",
      // prop: "articleTitle",
      minWidth: "240",
      fixed: "left",
      render: vo => <ArticleTitle vo={vo} />
    },
    {
      label: "所属期刊",
      prop: "periodicalName",
      minWidth: "80",
      showOverflowTooltip: true,
    },
    {
      label: "期刊期次",
      prop: "periodicalPeriod",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "来源",
      prop: "newsSource",
      width: "120",
      render: (vo) => <NewsSource vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "作者",
      prop: "articleAuthor",
      minWidth: "80",
      render: (vo) => <ArticleAuthor vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "展示终端",
      prop: "clientNames",
      width: "150",
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "版权方",
      prop: "originDeptName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "已共享学院",
      prop: "sharedDeptNames",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      width: "160",
      fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
